
import { defineComponent } from 'vue'
import store from '@/store'
import { scoreTitle } from '@/textConfig'

export default defineComponent({
  data() {
    return { scoreTitle }
  },
  computed: {
    score(): number {
      return store.getters.score
    },
  },
})
